/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_oscuro.svg'
import {SECCIONES} from "../../Constantes";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";

const BarraPc = () => {


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={12}
                sx={{maxWidth: '1400px', px: 3, py: 4}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 4}}>
                    <img src={logo} width={120} height={'auto'} alt={'logo jose arturo'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} justifyContent={'flex-end'}>
                    <Grid
                        container
                        justifyContent={'flex-end'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        {SECCIONES.map((it, index) => {
                            return (
                                <Grid item justifyContent={'flex-end'}>
                                    <Typography
                                        onClick={() => scrolearAComponente(it)}
                                        sx={{
                                            cursor: 'pointer',
                                            transition: "all .2s ease-in-out",
                                            px: 3,
                                            py: 0.5,
                                            borderRadius: 6,
                                            backgroundColor: '#ffffff00',
                                            fontWeight: 800,
                                            fontSize: 16,
                                            '&:hover': {
                                                backgroundColor: '#9CAD6C',
                                            }
                                        }}>{it}</Typography>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default BarraPc